var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFingerPrint = function SvgFingerPrint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4558 3.93604C12.2157 2.77261 14.2579 2.10771 16.3655 2.01202C18.473 1.91633 20.5671 2.39341 22.4252 3.39256C24.2833 4.39171 25.836 5.8756 26.9183 7.68655C28.0005 9.49749 28.572 11.5678 28.5718 13.6775C28.5718 18.2237 27.7062 22.5658 26.1306 26.5499M7.15207 7.23821C5.88718 9.14726 5.21447 11.3875 5.21841 13.6775C5.22207 15.8774 4.6012 18.0332 3.42798 19.8942M6.52464 25.4352C9.44697 22.2172 11.0631 18.0244 11.0568 13.6775C11.0568 12.1291 11.6719 10.6441 12.7668 9.54918C13.8617 8.45428 15.3467 7.83917 16.8951 7.83917C18.4435 7.83917 19.9285 8.45428 21.0235 9.54918C22.1184 10.6441 22.7335 12.1291 22.7335 13.6775C22.7335 14.498 22.7008 15.3107 22.6338 16.1141M16.8951 13.6775C16.9038 19.2452 14.9151 24.6312 11.2903 28.8572M21.6172 21.7018C20.7741 24.6549 19.4683 27.4557 17.7483 30",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgFingerPrint;